import {Component, OnInit, AfterViewInit, Input, Output, ViewEncapsulation  } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-vendor-create-pipeline-dialog.component',
    templateUrl: 'vendor-create-pipeline-dialog.component.html',
    styleUrls: ['vendor-create-pipeline-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None
  })

  export class VendorCreatePipelineDialogComponent implements OnInit {
    
    constructor(public matDialogRef: MatDialogRef<VendorCreatePipelineDialogComponent>) {

    }
  
    ngOnInit() {

    }

    close() {
      this.matDialogRef.close();
    }

  }